export default function FinalStage() {
  const scrollToForm = () => {
    const form = document.getElementById("form-hero");
    if (form) form.scrollIntoView({ behavior: "smooth", block: "center" });
  };

  return (
    <section
      className="py-20 sm:py-28 relative overflow-hidden bg-gradient-to-br from-gray-950 via-[#0a0a1a] to-gray-950"
      id="participacao-especial"
    >
      <div className="absolute top-0 left-0 w-72 h-72 bg-yellow-500/5 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2" />
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-yellow-500/5 rounded-full blur-3xl translate-x-1/3 translate-y-1/3" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-yellow-500/5 rounded-full blur-[120px]" />

      <div className="max-w-6xl mx-auto px-4 sm:px-6 relative z-10">
        <div className="text-center mb-12 sm:mb-16">
          <div className="inline-flex items-center gap-2 bg-yellow-500/10 border border-yellow-500/20 rounded-full px-5 py-2 mb-6">
            <i className="ri-star-fill text-yellow-500 text-sm" />
            <span className="text-yellow-500 text-xs sm:text-sm font-semibold tracking-wider uppercase">
              Participação Especial Confirmada
            </span>
            <i className="ri-star-fill text-yellow-500 text-sm" />
          </div>
          <h4 className="text-3xl sm:text-4xl md:text-5xl font-black text-white">
            Etapa{" "}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-yellow-600">
              Final
            </span>
          </h4>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          {/* Photo */}
          <div className="flex justify-center lg:justify-end">
            <div className="relative">
              <div className="absolute -inset-4 bg-gradient-to-br from-yellow-500/20 to-yellow-600/10 rounded-3xl blur-2xl" />
              <div className="relative w-[320px] h-[420px] sm:w-[380px] sm:h-[480px] rounded-2xl overflow-hidden border border-yellow-500/20">
                <img
                  alt="Léo Belmonte - Ator brasileiro conhecido por Carrossel e 3% Netflix"
                  title="Léo Belmonte ator participação especial Four Models"
                  className="w-full h-full object-cover object-top"
                  src="https://static.readdy.ai/image/103ec5ada18b00c7d95516c6aa3b7243/bcdca41a21e27164614ffcdeaee4e2ad.jpeg"
                />
                <div className="absolute bottom-0 inset-x-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent h-32" />
              </div>
              <div className="absolute -top-3 -right-3 w-12 h-12 bg-gradient-to-br from-yellow-500 to-yellow-600 rounded-xl flex items-center justify-center rotate-6">
                <i className="ri-clapperboard-fill text-black text-xl" />
              </div>
            </div>
          </div>

          {/* Content */}
          <div className="text-center lg:text-left">
            <div className="flex items-center gap-2 justify-center lg:justify-start mb-2">
              <div className="w-8 h-[2px] bg-yellow-500" />
              <span className="text-yellow-500 text-xs font-semibold tracking-widest uppercase">
                Convidado Especial
              </span>
            </div>
            <h3 className="text-3xl sm:text-4xl md:text-5xl font-black mb-2">
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 via-yellow-500 to-yellow-600">
                Léo Belmonte
              </span>
            </h3>
            <p className="text-gray-400 text-sm sm:text-base font-medium mb-8 flex items-center gap-2 justify-center lg:justify-start">
              <i className="ri-film-fill text-yellow-500/70 text-base" />
              Ator • Carrossel (SBT) • 3% (Netflix)
            </p>

            <div className="space-y-5 mb-10">
              <p className="text-gray-300 text-sm sm:text-base leading-relaxed">
                Na etapa final da <strong className="text-white">Convenção Four Models</strong>, contaremos com a
                participação especial do ator <strong className="text-white">Léo Belmonte</strong>, conhecido por
                interpretar <strong className="text-white">Jorge na novela Carrossel (SBT)</strong>, além de
                participação na série <strong className="text-white">3% da Netflix</strong> e outros trabalhos no
                audiovisual brasileiro.
              </p>
              <p className="text-gray-300 text-sm sm:text-base leading-relaxed">
                Sua presença reforça o compromisso da <strong className="text-white">Four Models</strong> em
                proporcionar{" "}
                <strong className="text-yellow-500">experiência real de mercado</strong>, conexão com profissionais
                atuantes e vivência prática no cenário artístico.
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 mb-8">
              {[
                { icon: "ri-tv-fill", title: "Carrossel", sub: "SBT" },
                { icon: "ri-netflix-fill", title: "3%", sub: "Netflix" },
                { icon: "ri-movie-2-fill", title: "Audiovisual", sub: "Brasileiro" },
              ].map((item) => (
                <div
                  key={item.title}
                  className="bg-white/5 border border-white/10 rounded-xl p-4 text-center"
                >
                  <div className="w-9 h-9 bg-yellow-500/10 rounded-lg flex items-center justify-center mx-auto mb-2">
                    <i className={`${item.icon} text-yellow-500 text-base`} />
                  </div>
                  <p className="text-white text-xs font-semibold">{item.title}</p>
                  <p className="text-gray-500 text-[11px]">{item.sub}</p>
                </div>
              ))}
            </div>

            <button
              onClick={scrollToForm}
              className="bg-gradient-to-r from-yellow-500 to-yellow-600 text-black px-8 sm:px-10 py-3.5 sm:py-4 rounded-full text-sm sm:text-base font-black hover:from-yellow-400 hover:to-yellow-500 transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              INSCREVER-SE AGORA
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
